import React from "react";

import { useT } from "../i18n";
import Seo from "../components/Seo";
import Reveal from "../components/motion/Reveal";
import { Button } from "../components/ui/primitives";

export default function NotFoundPage() {
  const { t } = useT();

  return (
    <>
      <Seo title={t("notFound.seoTitle")} description="" />

      <section className="shell flex flex-col items-center gap-7 py-32 text-center lg:py-[244px]">
        <Reveal>
          <h1 className="t-display max-w-[820px]">{t("notFound.title")}</h1>
        </Reveal>
        <Reveal delay={90}>
          <p className="t-lede max-w-[560px]">{t("notFound.body")}</p>
        </Reveal>
        <Reveal delay={170} className="pt-2">
          <Button to="/" variant="light">
            {t("notFound.cta")}
          </Button>
        </Reveal>
      </section>
    </>
  );
}
